import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    noData: '无搜索结果'
  },
  {
    ns: 'dropdown'
  }
)
